import {Inject, Injectable} from "ng-metadata/core";
import {getVid} from "../../appConfig/appConfigForward";

interface ValidateCaptchaResponse {
    success: boolean;
}

@Injectable()
export class CaptchaService {
    private validateCaptchaUrl: string;

    constructor(
        @Inject('$http') private $http: ng.IHttpService,
        @Inject('restBaseURLs') private restBaseURLs
    ) {
        this.validateCaptchaUrl = this.restBaseURLs.actionsBaseURL + '/validateCaptcha';
    }

    public validateCaptchaResponse(captchaResponse: string, context?: string): Promise<void> {
        if (!captchaResponse) {
            return Promise.reject('Empty captcha response');
        }
        return new Promise((resolve, reject) => {
            const httpOptions = {
                headers: ({
                    'Content-Type': 'text/plain'
                }),
                params: {
                    context: context || '',
                    vid: getVid()
                }
            };
            this.$http.post<ValidateCaptchaResponse>(this.validateCaptchaUrl, captchaResponse, httpOptions).then((response: any) => {
                const data: ValidateCaptchaResponse = response.data;
                if (data && data.success) {
                    resolve();
                } else {
                    reject(data);
                }
            }).catch((error: any) => {
                reject(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/captcha/captcha.service.ts